import { shallowRef } from 'vue';

import type { PerpsPosition } from '@exchange/libs/account/service/src/lib/wss-account-messages.js';
import { modalService } from '@exchange/libs/modals/src';
import { toastManagerInstance, SimpleToast } from '@exchange/libs/toasts/src';

import ClosePositionForm from '../../../ui/src/lib/positions/ClosePositionForm.vue';

export const handleClosePosition = (position: PerpsPosition) => {
  const mKey = modalService.show(
    shallowRef(ClosePositionForm),
    { position },
    {
      submit: () => {
        toastManagerInstance.addToast({
          content: SimpleToast,
          props: {
            variant: 'default',
            title: 'Closing position...',
          },
        });
        modalService.hide(mKey);
      },
      close: () => {
        modalService.hide(mKey);
      },
    },
    { canClose: true, centered: true, variant: 'dark' },
  );
};
